import useSWRImmutable from 'swr/immutable';

import { useCurrentUser } from 'hooks/use-current-user';
import { CompanyProfileService } from 'services/CompanyProfileService';

const useSupportCompanies = () => {
    const user = useCurrentUser();

    const { data } = useSWRImmutable(
        user ? `support-companies-${user.id}` : null,
        user ? () => CompanyProfileService.getBySupportUser(user.id) : null,
    );

    return data?.docs || [];
};

export { useSupportCompanies };
